import React, { useEffect, useState } from "react";
import "./EmailCustomerStyles.scss";
import { EmailDataFetching } from "./emailDataFetching";
import { useSelector, useDispatch } from "react-redux";
import { getFunnelOptimizerStatus } from "../../helper/Controllers/StatusController";
import Overlay from "../../components/NoDataFoundPage/NoDataFoundPage";
import {
  setEmailsSent,
  setEmailUpdatedStatusDone,
  setExtraData,
  setEmailActivities,
  setCurrentDay,
  setEmailStats,
  setPage,
} from "./emailSlice";
import { FirebaseDataService } from "../../services/firebase-data.service";
import { Http_service } from "../../services/http-service";
import { EmailTemplates } from "./EmailTemplates";
import { LoadingAnimation } from "../../components/Loading/LoadingAnimation";
import { selectLogInUsername } from "../../common/authenticateDashboard/authSlice";
const EmailCustomers = () => {
  const emailData = new EmailDataFetching();
  const [funnelOptimizerFetchLoading, setFunnelOptimizerFetchLoading] = useState(true);
  const sessionUser = useSelector(selectLogInUsername)
  const user = sessionUser?.split('@')[0];


  const firebaseDataService = new FirebaseDataService();
  const http_service = new Http_service();
  const dispatch = useDispatch();

  // Current page, page 1 = default, page 2 = email template
  const page = useSelector((state) => state.emailCustomer.page);

  // All dates to choose from
  const dates = useSelector((state) => state.emailCustomer.dates);
  // Current Date displayed
  const currentDay = useSelector((state) => state.emailCustomer.currentDay);
  // Customer names, emails, and products
  const customerLists = useSelector(
    (state) => state.emailCustomer.customerLists
  );
  // No data found flag
  const dataNotFoundStatus = useSelector(
    (state) => state.emailCustomer.dataNotFoundStatus
  );
  // List of dates where emails were sent or not - timestamps
  const insightWeeks = useSelector((state) => state.emailCustomer.insightWeeks);
  // Data corresponding to insight weeks above
  const insightData = useSelector((state) => state.emailCustomer.insightData);
  // How many emails sent each day
  const emailsSent = useSelector((state) => state.emailCustomer.emailsSent);
  // Flags for rendering bottom update email status button
  const emailUpdatedStatusDone = useSelector(
    (state) => state.emailCustomer.emailUpdatedStatusDone
  );
  // User company details
  const companyDetails = useSelector(
    (state) => state.emailCustomer.companyDetails
  );
  // Used for sending emails
  const currCustomerWeekData = useSelector(
    (state) => state.emailCustomer.currCustomerWeekData
  );
  // Default products to be displayed where no alternative
  const genericProducts = useSelector(
    (state) => state.emailCustomer.companyGenericProducts
  );
  // Email updated button pressed -> email stats data (clicked, open, invalid)
  const emailStats = useSelector((state) => state.emailCustomer.emailStats);
  // Email updated button pressed -> email activities data
  const emailActivities = useSelector(
    (state) => state.emailCustomer.emailActivities
  );


  const [emailUpdatedStatus, setEmailUpdatedStatus] = React.useState();
  const [dateToChangeTo, setDateToChangeTo] = React.useState(0);
  const [loading, setLoading] = React.useState(true);

  // Send email to customer states
  const [senderName, setSenderName] = React.useState("");
  const [senderEmail, setSenderEmail] = React.useState("");
  const [emailSubject, setEmailSubject] = React.useState(
    "You left something behind"
  );
  const [senderDetailsMessage, setSenderDetailsMessage] = React.useState("");

  const [optimizerStatus, setOptimizerStatus] = useState(false);
  useEffect(() => {
    const fetch = async () => {
      const response = await getFunnelOptimizerStatus();
      setOptimizerStatus(response);
      setFunnelOptimizerFetchLoading(false);
    };
    fetch();
  },[]);

  /**
   * Calls functions from the EmailDataFetching class that update
   * the state on mount.
   *
   * Data is organized as follows:
   * Every list of data is stored as an array with each element representing
   * one day. In the insight weeks and insight data, there are less days worth
   * of data than the customerLists and dates arrays, but every element in every
   * array has a corresponding element in every other array based on its position
   * and the day that data represents.
   *
   * Mostly, the data is displayed by mapping through the main list of data,
   * customerLists, and using the retrieved index of every element to access the
   * corresponding element for that day in the other arrays
   */
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customerLists.length === 0 || dataNotFoundStatus) {
          // Get initial company data
          emailData.graphCompanyDetailsFetching();

          // Initialize rest of data if there is data to be found
          if (!emailData.data_not_found_status) {
            // Update emailData object
            emailData.graphSentEmailInsightsFetching();

            // Store in state some data for sending emails
            setTimeout(() => {
              dispatch(
                setExtraData({
                  currCustomerWeekData: emailData.Curr_Customer_week,
                  companyDetails: emailData.companyDetails,
                  companyGenericProducts:
                    emailData.companyGenericProducts.filter(
                      (value) => value !== null
                    ),
                })
              );

              // Initialize all email stats to zero
              dispatch(
                setEmailStats(
                  emailData.Customer_Details_Labels.map(() => {
                    return {
                      opened: 0,
                      clicked: 0,
                      invalid: 0,
                    };
                  })
                )
              );
            }, 1000);
          }
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  /**
   * Calculates some user data, such as emails sent,
   * once insights data have been retrieved.
   */
  useEffect(() => {
    let emailsSentArray;
    let updatedStatusDoneArray = [];
    if (emailsSent.length === 0) {
      // Return array of numbers representing the emails sent on
      // each day
      emailsSentArray = customerLists.map((value, index) => {
        // Initialize array of updatedStatusDone values
        updatedStatusDoneArray[index] = false;

        // Initialize list of data where each element corresponds to a day
        if (
          insightWeeks.includes(dates[index]) &&
          insightData[insightWeeks.indexOf(dates[index])].emailSent_Status
        ) {
          return customerLists[index].length;
        } else {
          return 0;
        }
      });
      dispatch(setEmailsSent(emailsSentArray));
      dispatch(setEmailUpdatedStatusDone(updatedStatusDoneArray));
      dispatch(setCurrentDay(dates.length - 1));
    }
  }, [insightData, insightWeeks, customerLists, dates]);

  /**
   * useEffect that resets updatedStatus useState when the day is
   * changed. This makes the email activities display go back to
   * its default state.
   */
  useEffect(() => {
    setEmailUpdatedStatus(false);
    setSenderDetailsMessage("");
  }, [currentDay]);

  /**
   * After clicking bottom update email status button,
   * display email sent data in email activites column.
   */
  function updateEmailStatus() {
    let statusArr = [...emailUpdatedStatusDone];
    statusArr[currentDay] = true;
    dispatch(setEmailUpdatedStatusDone(statusArr));

    updateEmailActivities(insightData[insightWeeks.indexOf(dates[currentDay])]);
    setEmailUpdatedStatus(true);
  }

  // Handles selecting a date in the date input box
  // and stores the value to be changed to when pressing view result
  function changeDateToChangeTo(datePicked) {
    setDateToChangeTo(datePicked);
  }
  // If stored date value to change to doesn't equal the
  // current date, change the date when view result is pressed
  function changeCurrentDay() {
    if (dates[currentDay] !== dateToChangeTo)
      dispatch(setCurrentDay(dates.indexOf(dateToChangeTo)));
  }

  // Formats the percentages in the user stats boxes
  function formatPercentage(num) {
    if (num % 1 === 0) {
      return num;
    }
    return num.toFixed(2);
  }

  // Sends email based on info from send email section at bottom
  function sendEmail(e) {
    e.preventDefault();
    emailSendToCustomer(senderName, senderEmail, emailSubject);
  }

  /**
   * handles sending email to selected customer
   */
  function emailSendToCustomer(senderName, senderEmail, emailSubject) {
    // Check that all email fields are filled
    if (senderName === "" && senderEmail === "") {
      setSenderDetailsMessage("Sender Name & Email fields are required");
      return;
    } else if (senderName === "") {
      setSenderDetailsMessage("Sender Name field is required");
      return;
    } else if (validateEmail(senderEmail) === null) {
      setSenderDetailsMessage("Sender Email fields is required [valid]");
      return;
    } else if (emailSubject === "") {
      setSenderDetailsMessage("Email Subject must be non-empty");
      return;
    }
    setSenderDetailsMessage("");
    let URL =
      "https://us-central1-causalfunnel-21.cloudfunctions.net/clientEmailsCustomer";
    // let URL = "http://localhost:5001/causalfunnel-21/us-central1/clientEmailsCustomer";

    let body = {
      senderDetail: {
        senderName: senderName,
        senderEmail: senderEmail,
        emailSubjet: emailSubject,
      },
      emailMsgBody: [...currCustomerWeekData],
      companyDetails: { ...companyDetails },
    };
    let headers = {
      "Content-Type": "application/json",
      Accept: "*/*",
      // "User-Agent": "http://localhost:4200",
      "User-Agent": "https://dashboard.causalfunnels.com",
    };

    fetch(URL, {
      method: "post",
      headers: headers,
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        let sentEmialIds = data["messageIds"];
        updateSentEmail_Data(sentEmialIds);
        console.log("sentEmailFinished", data);
      })
      .catch((err) => {
        setSenderDetailsMessage("Email failed to send");
        return;
      });

    setSenderDetailsMessage("Sent");

    function updateSentEmail_Data(sentEmialIds) {
      const current_time = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      let new_selected_date = current_time.slice(0, 10).replaceAll("-", "");

      if (typeof dates[dates.length - 1] === "string") {
        new_selected_date = dates[dates.length - 1];
        new_selected_date = new_selected_date.replaceAll("-", "");
      }

      let emailStatus_graphNode = `graph-sentEmailInsights/${new_selected_date}`;
      let emailMsgIds_graphNode = `graph-sentEmailInsights/${new_selected_date}/emailSent-data`;
      let email_sent_Data = { emailSent: "true" };
      let email_msg_body = {
        [current_time]: {
          messageIds: sentEmialIds,
        },
      };

      firebaseDataService.dataUpdateInDB(
        user,
        emailStatus_graphNode,
        email_sent_Data
      );
      firebaseDataService.dataUpdateInDB(
        user,
        emailMsgIds_graphNode,
        email_msg_body
      );
    }

    function validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }
  }

  /**
   * Updates values like emails clicked, opened, and invalid in user stats boxes
   *  and updates email activities
   */
  function updateEmailActivities(insightData) {
    let sent_emials_id;
    let sendBlue_ApiCall = 0;

    sent_emials_id = Object.values(insightData["emailSent_Ids"]);
    let last_batch_id = Object.values(
      sent_emials_id[sent_emials_id.length - 1]
    );

    let email_opened = 0;
    let email_clicked = 0;
    let email_invalid = 0;
    let emailActivitiesData = [];

    // For each item in the list of addresses in insight data
    const promiseArray = last_batch_id.map(async (item, index) => {
      let id = item.split("@smtp-relay.mailin.fr>")[0];
      id = id.substring(1);
      let full_id = `%3C${id}%40smtp-relay.mailin.fr%3E`;
      let url = `https://api.sendinblue.com/v3/smtp/statistics/events?limit=50&offset=0&messageId=${full_id}&sort=desc`;

      // console.log(item)

      const response = await http_service.Check_Sent_Email_Status(url);
      // console.log("response", response);
      sendBlue_ApiCall += 1;
      let user_email_action = [];
      let user_email_data = {};

      if (
        Object.keys(response).length !== 0 &&
        response.data.events !== undefined
      ) {
        let activities = response.data.events;
        let user_email = activities[0]["email"];

        // console.log('userEmail', user_email)
        activities.map((i) => {
          if (i["email"] !== "hi@causalfunnel.com") {
            user_email = i["email"];
            let t = {};
            t["event"] = i.event;

            if (i.event === "opened") {
              email_opened += 1;
            } else if (i.event === "clicks") {
              email_clicked += 1;
            } else if (i.event === "hardBounces") {
              email_invalid += 1;
            }
            let date_with_time = i.date;
            date_with_time = date_with_time.replace("T", " ");
            date_with_time = date_with_time.replace(/\.\d+/, " ");
            t["date"] = date_with_time;
            user_email_action.push(t);
          }
        });
        user_email_data[user_email] = user_email_action;
      }
      let new_selected_date = dates[currentDay];
      new_selected_date = new_selected_date.replaceAll("-", "");
      user_email_data = Object.values(user_email_data)[0].map((value) => {
        return Object.values(value);
      });
      emailActivitiesData[index] = user_email_data;
      return user_email_data;
    });

    Promise.all(promiseArray).then(() => {
      // Runs only after forEach loop is completed
      updateEmailActivities(
        email_opened,
        email_clicked,
        email_invalid,
        emailActivitiesData
      );
    });

    function updateEmailActivities(
      email_opened,
      email_clicked,
      email_invalid,
      emailActivitiesData
    ) {
      // Set current email stats box data
      let currentDayEmailStats = {
        opened: email_opened,
        clicked: email_clicked,
        invalid: email_invalid,
      };
      let newEmailStats = [...emailStats];
      newEmailStats[currentDay] = currentDayEmailStats;
      dispatch(setEmailStats(newEmailStats));

      // Set email activites data
      let newEmailActivities = { ...emailActivities };
      newEmailActivities[currentDay] = emailActivitiesData;
      dispatch(setEmailActivities(newEmailActivities));
    }
  }

  if(funnelOptimizerFetchLoading === true){
    return <LoadingAnimation />
  }

  return (
    <>
    
    {
      optimizerStatus?(
        <div className="bg-purple-400 flex-grow p-3.5" >
        {/* Buttons */}
        {page === "page 1" ? (
          <div>
            <div className="flex justify-left ml-4 gap-3 mt-4">
              <button className="text-white bg-[#3c5d95] px-4 p-1 rounded-5">
                Email Customers
              </button>
              <button
                onClick={() => dispatch(setPage("page 2"))}
                className="text-[rgba(30,100,160,1)] bg-white px-3 p-1 rounded-5 hover:bg-[rgba(0,0,0,0.08)]"
              >
                Email Templates
              </button>
            </div>
          </div>
        ) : (
          <div>
            <div className="flex justify-left ml-4 gap-3 mt-4">
              <button
                onClick={() => dispatch(setPage("page 1"))}
                className="text-[30,100,160,1] bg-white px-4 p-1 rounded-5 hover:bg-[rgba(0,0,0,0.08)]"
              >
                Email Customers
              </button>
              <button className="text-white bg-[#3c5d95] px-3 p-1 rounded-5">
                Email Templates
              </button>
            </div>
          </div>
        )}
  
        <div
          className="bg-white mt-4 rounded-3 p-4 pt-2"
          style={{ width: "100%", boxShadow: "2px 5px 8px rgba(0,0,0,0.2)" }}
        >
          {page === "page 2" ? (
            <EmailTemplates />
          ) : (
            <div className="flex flex-col">
              {/* Title */}
              <div
                className="h-10 mt-2 fs-5 fw-bold"
                style={{ borderBottom: "1px solid rgba(0,0,0,0.1)" }}
              >
                Products View User Details
              </div>
  
              {dataNotFoundStatus || loading ? (
                // Data not found display
                <div
                  className="fs-1 pt-3 fw-bold mt-4 mb-4 flex justify-content-center"
                  style={{ color: "gray" }}
                >
                  <div>Oops! Data Not Found</div>
                </div>
              ) : (
                <div>
                  <p
                    style={{
                      color: "#3c5d95",
                      fontSize: "12px",
                      margin: "15px 0px 10px",
                    }}
                  >
                    Selected Date
                  </p>
  
                  {/* Date and result buttons */}
                  <div className="flex flex-row flex-wrap gap-4">
                    <div
                      className="p-2.5 flex gap-1 rounded-2"
                      style={{
                        fontSize: "14px",
                        border: "1px solid rgba(0,0,0,0.15)",
                      }}
                    >
                      <input
                        className="date__selector"
                        type="date"
                        defaultValue={dates[currentDay]}
                        min={dates[0]}
                        max={dates[dates.length - 1]}
                        onChange={(e) => changeDateToChangeTo(e.target.value)}
                      />
                    </div>
  
                    <button
                      className="view__result__button"
                      onClick={() => changeCurrentDay()}
                    >
                      View Result
                    </button>
                  </div>
  
                  {dates[currentDay] === undefined ||
                  customerLists.length === 0 ? (
                    // Data not found display
                    <div
                      className="fs-1 pt-3 fw-bold mt-4 mb-4 flex justify-content-center"
                      style={{
                        color: "gray",
                        borderTop: "1px solid rgba(0,0,0,0.1)",
                      }}
                    >
                      <div>Oops! Data Not Found</div>
                    </div>
                  ) : (
                    <div>
                      {/* User stats row */}
                      {/* Total Users */}
                      <div className="flex flex-row flex-wrap mt-4 text-[#3c5d95]">
                        <div className="user__stats__box">
                          <p style={{ fontSize: "12.5px" }}>Total Users</p>
                          <div className="user__stats__bottom">
                            {customerLists[currentDay].length}
                          </div>
                        </div>
                        {/* Emails not sent */}
                        <div className="user__stats__box">
                          <p style={{ fontSize: "12.5px" }}>Emails not sent</p>
                          <div className="user__stats__bottom">
                            <p>
                              {customerLists[currentDay].length -
                                emailsSent[currentDay]}
                            </p>
                            <p
                              className="mr-1.5 text-[red]"
                              style={{ fontSize: "15.5px" }}
                            >
                              {formatPercentage(
                                ((customerLists[currentDay].length -
                                  emailsSent[currentDay]) /
                                  customerLists[currentDay].length) *
                                  100
                              )}
                              %
                            </p>
                          </div>
                        </div>
                        {/* Emails sent */}
                        <div className="user__stats__box">
                          <p style={{ fontSize: "12.5px" }}>Emails sent</p>
                          <div className="user__stats__bottom">
                            {emailsSent[currentDay]}
                            <p
                              className="mr-1.5 text-[green]"
                              style={{ fontSize: "15.5px" }}
                            >
                              {formatPercentage(
                                (emailsSent[currentDay] /
                                  customerLists[currentDay].length) *
                                  100
                              )}
                              %
                            </p>
                          </div>
                        </div>
                        {emailStats.length === 0 ? (
                          <></>
                        ) : (
                          <>
                            {/* Opened */}
                            <div className="user__stats__box">
                              <p style={{ fontSize: "12.5px" }}>Opened</p>
                              <div className="user__stats__bottom">
                                {emailStats[currentDay].opened}
                                <p
                                  className="mr-1.5 text-[violet]"
                                  style={{ fontSize: "15.5px" }}
                                >
                                  {formatPercentage(
                                    (emailStats[currentDay].opened /
                                      customerLists[currentDay].length) *
                                      100
                                  )}
                                  %
                                </p>
                              </div>
                            </div>
                            {/* Clicked */}
                            <div className="user__stats__box">
                              <p style={{ fontSize: "12.5px" }}>Clicked</p>
                              <div className="user__stats__bottom">
                                {emailStats[currentDay].clicked}
                                <p
                                  className="mr-1.5 text-[turquoise]"
                                  style={{ fontSize: "15.5px" }}
                                >
                                  {formatPercentage(
                                    (emailStats[currentDay].clicked /
                                      customerLists[currentDay].length) *
                                      100
                                  )}
                                  %
                                </p>
                              </div>
                            </div>
                            {/* Invalid emails */}
                            <div className="user__stats__box">
                              <p style={{ fontSize: "12.5px" }}>Invalid emails</p>
                              <div className="user__stats__bottom">
                                {emailStats[currentDay].invalid}
                                <p
                                  className="mr-1.5 text-[brown]"
                                  style={{ fontSize: "15.5px" }}
                                >
                                  {formatPercentage(
                                    (emailStats[currentDay].invalid /
                                      customerLists[currentDay].length) *
                                      100
                                  )}
                                  %
                                </p>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
  
                      {/* All data */}
                      <div
                        className="flex flex-col mt-3"
                        style={{
                          overflowX: "scroll",
                          width: "100%",
                          border: "1px solid rgba(0,0,0,0.15)",
                        }}
                      >
                        <div
                          className="flex fw-bold p-2.5"
                          style={{ fontSize: "13px", height: "40px" }}
                        >
                          <p style={{ marginLeft: "5px" }}>S.No.</p>
                          <p style={{ marginLeft: "35px" }}>Name</p>
                          <p style={{ marginLeft: "130px" }}>Email</p>
                          <p
                            className="text-nowrap"
                            style={{ marginLeft: "180px" }}
                          >
                            Product 1
                          </p>
                          <p
                            className="text-nowrap"
                            style={{ marginLeft: "110px" }}
                          >
                            Product 2
                          </p>
                          <p
                            className="text-nowrap"
                            style={{ marginLeft: "110px" }}
                          >
                            Product 3
                          </p>
                          <div
                            className="text-nowrap"
                            style={{ marginLeft: "120px" }}
                          >
                            Email Activities With Timestamp
                          </div>
                          <div className="ml-20" style={{ opacity: "0" }}>
                            .
                          </div>
                        </div>
  
                        {customerLists[currentDay].map((value, index) => (
                          <div key={index}>
                            <div
                              className="relative"
                              style={{
                                width: "1350px",
                                height: "1.5px",
                                backgroundColor: "rgba(0,0,0,0.1)",
                              }}
                            />
  
                            <div
                              className="flex p-2.5 relative"
                              style={{ fontSize: "13px", height: "200px" }}
                            >
                              {/* Serial No */}
                              <div
                                className="absolute w-8"
                                style={{ marginLeft: "5px" }}
                              >
                                {index + 1}
                              </div>
                              {/* Names */}
                              <div
                                className="absolute"
                                style={{
                                  marginLeft: "70px",
                                  width: "150px",
                                  wordWrap: "break-word",
                                }}
                              >
                                {customerLists[currentDay][index].name}
                              </div>
                              {/* Emails */}
                              <div
                                className="w-36 absolute"
                                style={{
                                  marginLeft: "240px",
                                  width: "190px",
                                  wordWrap: "break-word",
                                }}
                              >
                                {customerLists[currentDay][index].email}
                              </div>
  
                              {/* Product 1 */}
                              <div
                                className="product"
                                style={{ marginLeft: "450px" }}
                              >
                                <a
                                  className="flex justify-content-center"
                                  href={`${
                                    customerLists[currentDay][index].products
                                      .length < 1 ||
                                    customerLists[currentDay][index]
                                      .products[0] === null
                                      ? !(genericProducts.length > 0)
                                        ? ""
                                        : genericProducts[0].product_url
                                      : customerLists[currentDay][index]
                                          .products[0].product_url
                                  }`}
                                >
                                  <img
                                    src={`${
                                      customerLists[currentDay][index].products
                                        .length < 1 ||
                                      customerLists[currentDay][index]
                                        .products[0] === null
                                        ? !(genericProducts.length > 0)
                                          ? ""
                                          : genericProducts[0].product_image_url
                                        : customerLists[currentDay][index]
                                            .products[0].product_image_url
                                    }`}
                                    alt="Error loading"
                                    style={{ width: "120px", height: "110px" }}
                                  />
                                </a>
                                <div className="flex justify-content-center align-text-center">
                                  {`${
                                    customerLists[currentDay][index].products
                                      .length < 1 ||
                                    customerLists[currentDay][index]
                                      .products[0] === null
                                      ? !(genericProducts.length > 0)
                                        ? ""
                                        : genericProducts[0].product_name
                                      : customerLists[currentDay][index]
                                          .products[0].product_name
                                  }`}
                                </div>
                              </div>
  
                              {/* Product 2 */}
                              <div
                                className="product"
                                style={{ marginLeft: "620px" }}
                              >
                                <a
                                  className="flex justify-content-center"
                                  href={`${
                                    customerLists[currentDay][index].products
                                      .length < 2 ||
                                    customerLists[currentDay][index]
                                      .products[1] === null
                                      ? !(genericProducts.length > 0)
                                        ? ""
                                        : genericProducts[1].product_url
                                      : customerLists[currentDay][index]
                                          .products[1].product_url
                                  }`}
                                >
                                  <img
                                    src={`${
                                      customerLists[currentDay][index].products
                                        .length < 2 ||
                                      customerLists[currentDay][index]
                                        .products[1] === null
                                        ? !(genericProducts.length > 0)
                                          ? ""
                                          : genericProducts[1].product_image_url
                                        : customerLists[currentDay][index]
                                            .products[1].product_image_url
                                    }`}
                                    alt="Error loading"
                                    style={{ width: "120px", height: "110px" }}
                                  />
                                </a>
                                <div className="flex justify-content-center align-text-center">
                                  {`${
                                    customerLists[currentDay][index].products
                                      .length < 2 ||
                                    customerLists[currentDay][index]
                                      .products[1] === null
                                      ? !(genericProducts.length > 0)
                                        ? ""
                                        : genericProducts[1].product_name
                                      : customerLists[currentDay][index]
                                          .products[1].product_name
                                  }`}
                                </div>
                              </div>
  
                              {/* Product 3 */}
                              <div
                                className="product"
                                style={{ marginLeft: "790px" }}
                              >
                                <a
                                  className="flex justify-content-center"
                                  href={`${
                                    customerLists[currentDay][index].products
                                      .length < 3 ||
                                    customerLists[currentDay][index]
                                      .products[2] === null
                                      ? !(genericProducts.length > 0)
                                        ? ""
                                        : genericProducts[2].product_url
                                      : customerLists[currentDay][index]
                                          .products[2].product_url
                                  }`}
                                >
                                  <img
                                    src={`${
                                      customerLists[currentDay][index].products
                                        .length < 3 ||
                                      customerLists[currentDay][index]
                                        .products[2] === null
                                        ? !(genericProducts.length > 0)
                                          ? ""
                                          : genericProducts[2].product_image_url
                                        : customerLists[currentDay][index]
                                            .products[2].product_image_url
                                    }`}
                                    alt="Error loading"
                                    style={{ width: "120px", height: "110px" }}
                                  />
                                </a>
                                <div className="flex justify-content-center align-text-center">
                                  {`${
                                    customerLists[currentDay][index].products
                                      .length < 3 ||
                                    customerLists[currentDay][index]
                                      .products[2] === null
                                      ? !(genericProducts.length > 0)
                                        ? ""
                                        : genericProducts[2].product_name
                                      : customerLists[currentDay][index]
                                          .products[2].product_name
                                  }`}
                                </div>
                              </div>
  
                              {/* Email activities */}
                              {insightWeeks.includes(dates[currentDay]) &&
                              insightData[insightWeeks.indexOf(dates[currentDay])]
                                .emailSent_Status === "true" ? (
                                <div>
                                  {emailUpdatedStatus &&
                                  emailActivities.length !== 0 ? (
                                    <div className="email__updated__display">
                                      {/* Email Activities when email updated status button pressed */}
                                      {emailActivities[currentDay][index] ===
                                      undefined ? (
                                        <div></div>
                                      ) : (
                                        <div>
                                          {emailActivities[currentDay][index].map(
                                            (value) => (
                                              <div className="email__activity">
                                                <div className="email__activity__bubble">
                                                  {value[0]}
                                                </div>
                                                <div>{value[1]}</div>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <div
                                      className="flex absolute gap-2"
                                      style={{
                                        marginLeft: "970px",
                                        width: "250px",
                                      }}
                                    >
                                      <div
                                        className="bg-[rgba(100,230,130)] p-1 px-3 rounded-4"
                                        style={{ fontSize: "14px" }}
                                      >
                                        Sent
                                      </div>
                                      <div
                                        className="mt-1"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          insightData[
                                            insightWeeks.indexOf(
                                              dates[currentDay]
                                            )
                                          ].emailSent_time
                                        }
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div
                                  className="flex absolute"
                                  style={{ marginLeft: "970px" }}
                                >
                                  <div
                                    className="text-nowrap bg-[rgba(255,150,130)] p-1 px-3 rounded-4"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Not Sent
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
  
                      {/* Either email status button or send email option */}
                      {insightWeeks.includes(dates[currentDay]) &&
                      insightData[insightWeeks.indexOf(dates[currentDay])]
                        .emailSent_Status === "true" ? (
                        <div>
                          {/* Check sent email status button */}
                          {/* Only display if  emailUpdateStatusDone is false*/}
                          <button
                            className={`sent__email__button ${
                              emailUpdatedStatusDone[currentDay] ? "hidden" : ""
                            }`}
                            onClick={() => updateEmailStatus()}
                          >
                            Check Sent Email Updated Status
                          </button>
                        </div>
                      ) : (
                        <div className="send__email__container flex flex-wrap">
                          {/* Sender name and sender email */}
                          <div className="flex flex-col">
                            <div className="send__email__name">Sender Name</div>
                            <input
                              className="send__email__input"
                              placeholder="sender name"
                              value={senderName}
                              onChange={(e) => {
                                setSenderName(e.target.value);
                              }}
                            />
                            <div className="send__email__name">Sender Email</div>
                            <input
                              className="send__email__input"
                              placeholder="sender email"
                              value={senderEmail}
                              onChange={(e) => {
                                setSenderEmail(e.target.value);
                              }}
                            />
                          </div>
                          {/* Email Subject */}
                          <div className="flex flex-col">
                            <div className="send__email__name">Email Subject</div>
                            <textarea
                              className="resizable__input"
                              value={emailSubject}
                              onChange={(e) => {
                                setEmailSubject(e.target.value);
                              }}
                            ></textarea>
                          </div>
                          {/* Send email button */}
                          <div className="flex flex-col gap-2">
                            <button
                              className="flex send__email__button"
                              onClick={(e) => sendEmail(e)}
                            >
                              Send Email
                            </button>
                            <div
                              className="sender__message"
                              style={{
                                color: `${
                                  senderDetailsMessage === "Sent"
                                    ? "rgba(0,220,0)"
                                    : "rgba(240,0,0)"
                                }`,
                              }}
                            >
                              {senderDetailsMessage}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    ) : <Overlay />}
    </>

  );
};

export default EmailCustomers;
